import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ShortObject } from '../../project-misc/data/project/short-json-object';
import { User } from 'projects/core/src/lib/login/data/user';

@JsonObject('model.CabinetType')
export class CabinetType extends AbstractModel {

  @JsonProperty(Boolean, 'active')
  active?: boolean;

    @JsonProperty(Number, 'id')
  id?: number;

  @JsonProperty(String, 'clazz')
  clazz?: string;

  @JsonProperty(String, 'color')
  color?: string;

  @JsonProperty(String, 'name')
  name?: string;

    @JsonProperty(Number, 'pos')
  pos?: number;

  @JsonProperty(String, 'title')
  title?: string;
}
